import { render } from "./Import.vue?vue&type=template&id=b81d360e&scoped=true"
import script from "./Import.vue?vue&type=script&lang=js"
export * from "./Import.vue?vue&type=script&lang=js"

import "./Import.vue?vue&type=style&index=0&id=b81d360e&scoped=true&lang=css"

import exportComponent from "E:\\backup\\Programowanie\\kurs\\vue\\cam-scrapper\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b81d360e"]])

export default __exports__